import { render, staticRenderFns } from "./character-counter.vue?vue&type=template&id=7c80ca61&"
import script from "./character-counter.vue?vue&type=script&lang=ts&"
export * from "./character-counter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c80ca61')) {
      api.createRecord('7c80ca61', component.options)
    } else {
      api.reload('7c80ca61', component.options)
    }
    module.hot.accept("./character-counter.vue?vue&type=template&id=7c80ca61&", function () {
      api.rerender('7c80ca61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/character-counter.vue"
export default component.exports